var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-table-size"},[_c('whole-multiselect',{staticClass:"whole-multiselect",attrs:{"options":_vm.tableSizeOptions,"trackBy":"id","showDescription":true},model:{value:(_vm.tableSize),callback:function ($$v) {_vm.tableSize=$$v},expression:"tableSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }